/**
 * Deploy-time configuration for the Next.js static export.
 * Values come from `NEXT_PUBLIC_*` env vars and are inlined at build time.
 */

function trimTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

function readEnv(value: string | undefined, fallback: string): string {
  const trimmed = value?.trim();
  return trimmed ? trimmed : fallback;
}

export const API_ORIGIN = trimTrailingSlash(
  readEnv(process.env.NEXT_PUBLIC_API_ORIGIN, 'https://api.spk2go.mobi'),
);

export const LOGIN_PATH = readEnv(process.env.NEXT_PUBLIC_LOGIN_PATH, '/api/auth/login');

export const LOGIN_WITH_CREDENTIALS = process.env.NEXT_PUBLIC_LOGIN_WITH_CREDENTIALS !== '0';

export const LEADS_ENDPOINT = readEnv(process.env.NEXT_PUBLIC_LEADS_ENDPOINT, '/api/submit.php');

export const TABLET_PORTAL_URL = trimTrailingSlash(
  readEnv(process.env.NEXT_PUBLIC_TABLET_PORTAL_URL, 'https://spk2go.mobi'),
);

export const CONTACT_EMAIL = readEnv(process.env.NEXT_PUBLIC_CONTACT_EMAIL, 'vboy.gm@gmail.com');

export const CONTACT_PHONE = readEnv(process.env.NEXT_PUBLIC_CONTACT_PHONE, '');

export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
